import { ComponentType } from 'react';
import {
  createFrontendModule,
  IconElement,
} from '@backstage/frontend-plugin-api';
import { IconBundleBlueprint } from '@backstage/plugin-app-react';
import { appIconMapping, getIconMapping } from '@xlrt/components';
import ApartmentIcon from '@mui/icons-material/Apartment';
import CategoryIcon from '@mui/icons-material/Category';
import ExtensionIcon from '@mui/icons-material/Extension';
import FeaturedPlayListIcon from '@mui/icons-material/FeaturedPlayList';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MemoryIcon from '@mui/icons-material/Memory';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import PeopleIcon from '@mui/icons-material/People';
import PersonIcon from '@mui/icons-material/Person';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import StorageIcon from '@mui/icons-material/Storage';

const toIconElements = (
  iconComponents: Record<
    string,
    ComponentType<{ fontSize?: 'inherit' | 'small' | 'medium' | 'large' }>
  >,
): Record<string, IconElement> =>
  Object.fromEntries(
    Object.entries(iconComponents).map(([key, Icon]) => [
      key,
      <Icon fontSize="inherit" />,
    ]),
  );

// The default app icons in @backstage/plugin-app are still registered as
// deprecated IconComponents, which triggers a console warning for every key
// left un-overridden. These are element versions of the same glyphs, covering
// the default keys that our own icon maps don't already replace.
const defaultIconOverrides: Record<string, IconElement> = {
  'kind:api': <ExtensionIcon fontSize="inherit" />,
  'kind:component': <MemoryIcon fontSize="inherit" />,
  'kind:domain': <ApartmentIcon fontSize="inherit" />,
  'kind:group': <PeopleIcon fontSize="inherit" />,
  'kind:location': <LocationOnIcon fontSize="inherit" />,
  'kind:system': <CategoryIcon fontSize="inherit" />,
  'kind:user': <PersonIcon fontSize="inherit" />,
  'kind:resource': <StorageIcon fontSize="inherit" />,
  'kind:template': <FeaturedPlayListIcon fontSize="inherit" />,
  star: <StarIcon fontSize="inherit" />,
  unstarred: <StarBorderIcon fontSize="inherit" />,
  externalLink: <OpenInNewIcon fontSize="inherit" />,
};

const appIconBundle = IconBundleBlueprint.make({
  name: 'xelerate-icon-bundle',
  params: {
    icons: {
      ...defaultIconOverrides,
      ...toIconElements({
        ...appIconMapping,
        ...getIconMapping(),
      }),
    },
  },
});

export const iconsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [appIconBundle],
});
